import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class BpAdministrationService {

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {}

  getOverrideDefinitionTypes() {
    return this.http.get<any[]>('api/getOverrideDefinitionTypes');
  }

  getOverrideStatusTypes() {
    return this.http.get<any[]>('api/getOverrideStatusTypes');
  }

  getBusinessProcessesOverride() {
    return this.http.get<any[]>('api/getBusinessProcessesOverride');
  }

  getStatesOverride(businessProcessId) {
    return this.http.get<any[]>(`api/getStatesOverride/${businessProcessId}`);
  }

  verifyInstaceId(businessProcessId, businessProcessInstanceId) {
    return this.http.get<Boolean>(`api/verifyInstaceId/${businessProcessId}/${businessProcessInstanceId}`);
  }

  requestOverrideInstanceById(businessProcessInstanceId, toStateName, automaticAllocation) {
    return this.http.post<any>('api/requestOverrideByInstanceId',
      { businessProcessInstanceId, toStateName, automaticAllocation });
  }

  requestOverrideInstanceByPeriod(params) {
    return this.http.post<number>('api/requestOverrideByPeriod', params);
  }

  requestOverrideInstanceByRetroactive(params) {
    return this.http.post<number>('api/requestOverrideByRetroactive', params);
  }

  requestPreDefinedOverrideBusinessProcessInstance(businessProcessInstanceId) {
    return this.http.get<any>(`api/requestPreDefinedOverrideBusinessProcessInstance/${businessProcessInstanceId}`);
  }

  cancelBusinessProcessInstance(businessProcessInstanceId) {
    return this.http.post<void>('api/cancelBusinessProcessInstance', businessProcessInstanceId);
  }

  getBusinessProcessViewsByInstanceId(businessProcessInstanceId) {
    return this.http.get<any[]>(`api/getBusinessProcessViewsByInstanceId/${businessProcessInstanceId}`);
  }

  createSchedulingWithOverrideInstance(param) {
    return this.http.post<number[]>('api/scheduling/createSchedulingWithOverrideInstance', param);
  }

  getPagedOverrideInstanceScheduling(pageIndex) {
    return this.http.get<any>(`api/scheduling/getPagedOverrideInstanceScheduling/${pageIndex}`);
  }

  deleteSchedulingWithOverrideInstance(param) {
    return this.http.post<void>('api/scheduling/deleteSchedulingWithOverrideInstance', param);
  }

  updateSchedulingWithOverrideInstance(param) {
    return this.http.post<void>('api/scheduling/updateSchedulingWithOverrideInstance', param);
  }

  getBusinessProcessesForManaging() {
    return this.http.get<any[]>('api/runtime/getBusinessProcessesForManaging');
  }

  getStatesForManaging(businessProcessId) {
    return this.http.get<any[]>(`api/runtime/getStatesForManaging/${businessProcessId}`);
  }

  searchQueueManager(param) {
    return this.http.post<any[]>('api/runtime/searchQueueManager', param);
  }

  transferBusinessProcessInstanceLocks(params) {
    return this.http.post<void>('api/runtime/transferBusinessProcessInstanceLocks', params);
  }

  unlockBusinessProcessInstances(params) {
    return this.http.post<void>('api/runtime/unlockBusinessProcessInstances', params);
  }

  lockBusinessProcessForHumanInteraction(businessProcessInstanceId) {
    return this.http.post<void>('api/runtime/lockBusinessProcessForHumanInteraction', businessProcessInstanceId);
  }

  shiftInstanceQueues(params) {
    return this.http.post<any>('api/runtime/shiftInstanceQueues', params);
  }
}
